//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectBodyList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"InputParm",1,0],[0,"Rename",1,0],[0,"SelFootType",1,0],[1,"SelectBotFace",0,"SelectBodyList",0],[1,"SelectHead",0,"SelectBodyList",0],[0,"Type",1,0]],[[[],"EditRegFile",{},0,0],[[],"EditDatabase",{},0,0]],[]];
SPLM.Tooling.SubInsertBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.SubInsertBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.SubInsertBuilder.Types = Object.freeze({
    "ParentOfSolidOwningPart" : "ParentOfSolidOwningPart", "ProdPart" : "ProdPart", "SolidOwningPart" : "SolidOwningPart", "CurrentWorkPart" : "CurrentWorkPart"});

SPLM.Tooling.SubInsertBuilder.Shape = Object.freeze({
    "Box" : "Box", "Cylinder" : "Cylinder"});

export default SPLM;